import React from 'react';
import { LazyImage } from 'components/image';
import { connectionContent } from 'utils/constant/siteIntro/landingPage';

function Index() {
    return (
        <>
            <div className="flex items-center justify-center min-h-screen">
                <div className="w-full max-w-6xl mx-auto mt-24">
                    <div className="flex flex-col items-center text-black">
                        <div className='text-2xl mx-2 md:text-3xl lg:text-[40px] mb-4 text-center'>
                            Meet People Offline & <span className='text-pink-500'>Strengthen</span>
                        </div>
                        <div className='text-2xl mx-2 md:text-3xl lg:text-[40px] mb-8 text-center'>Your Connection</div>

                        <div className="w-full">
                            {connectionContent?.map((item, index) => (
                                <div key={index} className='mt-4'>
                                    {item?.imgLeft ?
                                        <>
                                            <div className="flex items-center justify-center w-full h-full">
                                                <div className="grid items-center justify-center grid-cols-1 gap-8 lg:grid-cols-2 md:gap-x-48">
                                                    {/* Text Section */}
                                                    <div className="order-1 p-4 text-center lg:text-left lg:order-2">
                                                        <div className="text-[20px] md:text-[40px]  text-black mb-4">{item?.mainText}</div>
                                                        <p className="text-base md:text-lg lg:text-xl text-subText">{item?.subText}</p>
                                                    </div>
                                                    {/* Image Section */}
                                                    <div className="flex items-center justify-center order-2 mx-2 lg:order-1">
                                                        <LazyImage src={item?.img} className="max-w-full lg:max-w-[430px] max-h-[450px] w-auto h-auto object-cover" />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="flex items-center justify-center w-full h-full">
                                                <div className="grid items-center justify-center grid-cols-1 gap-8 lg:grid-cols-2 md:gap-48">
                                                    {/* Text Section */}
                                                    <div className="order-1 p-4 text-center lg:text-left">
                                                        <div className="text-[20px] md:text-[40px]  text-black mb-4">{item?.mainText}</div>
                                                        <p className="text-base md:text-lg text-subText">{item?.subText}</p>
                                                    </div>
                                                    {/* Image Section */}
                                                    <div className="flex items-center justify-center order-2 mx-2">
                                                        <LazyImage src={item?.img} className="max-w-full lg:max-w-[430px] max-h-[450px] w-auto h-auto object-cover" />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default React.memo(Index);
